import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 网络请求
import axios from "axios";

axios.defaults.baseURL = "https://www.songxichen.com/songxichen.api";
// axios.defaults.headers.post["Content-Type"] = "application/json";
Vue.prototype.$axios = axios;
Vue.use(ElementUI);

Vue.config.productionTip = false;



// Uncaught (in promise) NavigationDuplicated {_name: "NavigationDuplicated"}的解决方法s
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};


// 获取IP地址 然后生成页面
axios
  // .post("/AQAssess/getData.php", {
  //   database: "IPs",
  // })
  .get("/AQAssess/getIPs")
  .then((res) => {
    
    Vue.prototype.$IPRecorded = res.data;

    new Vue({
      router,
      render: (h) => h(App),
    }).$mount("#app");

  });



